import 'requirejs/require.js'
import 'es6-promise/auto'

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import { i18n } from './localization'
import Environment from '@/plugins/environment'
import Auth, { idAuthenticator } from '@/plugins/auth'
import Feature from '@/plugins/feature'
import labService from './services/lab'
import VueProgressiveImage from 'vue-progressive-image'
import Metrics from './services/metrics'
import routerUtil from './router/router-util'
import clampy from '@clampy-js/vue-clampy'
import mixpanel from './services/mixpanel'
import vueMeta from 'vue-meta'
import { routeGuard } from './router/route-guard'
import { ID, LAB } from './enums/clients'

require('./styles/styles.scss')

Metrics.initialize()

Vue.config.productionTip = false

Environment.determineServiceRegion().then(() => {
  const idUrl = Environment.serviceUrlFor(ID)
  const LABUrl = Environment.serviceUrlFor(LAB)
  Vue.use(VueProgressiveImage)
  let PROJECT_ID = 'contentportal.smarttech.com'

  window.require.config({
    paths: {
      smartid: idUrl + '/static/js/signin',
      LABPlayer: LABUrl + '/lib/lab'
    }
  })

  window.require(['smartid', 'LABPlayer'], function(smartid, LABPlayer) {
    Vue.use(Auth)
    Vue.use(clampy)
    Vue.use(Feature)
    Vue.use(vueMeta)

    labService.init(LABPlayer)
    idAuthenticator.injectSMARTID(smartid, PROJECT_ID, [
      'profile.email',
      'scope:api.smarttech.com/account/data',
      'scope:api.smarttech.com/account/data/read',
      'scope:content.amp.smarttech.com/content/read',
      'scope:content.amp.smarttech.com/upload',
      'scope:smarttech.com/content_portal',
      'scope:content.amp.smarttech.com/content/update'
    ])
    const authPluginConfig = {
      authenticators: [idAuthenticator]
    }

    Promise.all([
      Auth.loadAuthenticators(authPluginConfig),
      Feature.load().catch()
    ])
      .catch(error => {
        console.error('ERROR: ' + JSON.stringify(error))
      })
      .then(() => {
        /* eslint-disable no-new */
        router.beforeEach((to, from, next) => {
          routeGuard(to, from, next)
        })
        mixpanel.init(Environment.getEnv())
        routerUtil.handleUrlRouting(window.location, router)
        new Vue({
          el: '#app',
          router,
          store,
          i18n,
          template: '<App/>',
          components: { App },
          directives: { clampy }
        })
        /* eslint-enable no-new */
      })
  })
})
